import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-handbookview',
  templateUrl: './handbookview.component.html',
  styleUrls: ['./handbookview.component.scss'],
})
export class HandbookviewComponent  implements OnInit {
  sanitizedUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { url: string; fileName: string },
    private sanitizer: DomSanitizer
  ) {
    // append the fragment that tells Chrome’s built‑in viewer to hide the toolbar
    const urlWithParams = `${data.url}#toolbar=0&navpanes=0&scrollbar=0`;
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithParams);
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

}
